import { Injectable, Type,inject } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { BiDialog } from './bi-dialog.component';
import { ICreateDialog } from 'bi-interfaces';
export class CreateDialog implements ICreateDialog  {
  public dialog = inject(MatDialog)
  DialogReturnSubject: Subject<any> = new Subject();
  DialogRef:any;
    constructor() { }
    // any component must implement innerComponet 
    public ShowDialog(component: Type<any>, data: any, modalTitle?: any,firstButtonName:any=null,secondButtonName:any=null,hasCancelBtn:boolean = true,hasOkBtn:boolean =  true) {
        this.DialogRef = this.dialog?.open(BiDialog, {
            data: {
              compo: component,
              dataToRenderedComponent: data,
              title: modalTitle,
              instance:this,
              firstButtonName:firstButtonName,
              secondButtonName:secondButtonName,
              hasCancelBtn:hasCancelBtn,
              hasOkBtn:hasOkBtn
            },
          });
          
    }
    public CloseDialog(){
      this.DialogRef.close();
    }
}